const trimSlash = (s) => (s || "").replace(/\/+$/, "");

export const config = {
  supabaseUrl: process.env.REACT_APP_SUPABASE_URL,
  supabaseAnonKey: process.env.REACT_APP_SUPABASE_ANON_KEY,
  turnstileSiteKey: process.env.REACT_APP_TURNSTILE_SITE_KEY,
  basePath: trimSlash(process.env.REACT_APP_BASE_PATH),
  brandName: process.env.REACT_APP_BRAND_NAME || "Real Match Matrimony",
  logoUrl: (() => {
    const v = process.env.REACT_APP_LOGO_URL || "/assets/logo.png";
    return v.startsWith("/") ? `${process.env.PUBLIC_URL || ""}${v}` : v;
  })(),
  websiteUrl: process.env.REACT_APP_WEBSITE_URL || "https://realmatchmatrimony.com/",
  termsUrl: process.env.REACT_APP_TERMS_URL || "https://realmatchmatrimony.com/terms-and-conditions/",
  privacyUrl: process.env.REACT_APP_PRIVACY_URL || "https://realmatchmatrimony.com/privacy-policy/",
};

export const appUrl = (path) => `${window.location.origin}${config.basePath}${path}`;
